import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, mergeProps, renderSlot, normalizeClass } from "vue";
import { useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { TooltipArrow_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipArrow.js";
import { TooltipContent_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipContent.js";
import { TooltipPortal_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipPortal.js";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tai_dab9c233f2e273c5e2a5498082090c73/node_modules/tailwind-variants/dist/index.js";
import "../../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
import { useConfigProvider } from "../../config-provider/useConfigProvider.js";
import { tooltipContentVariants } from "../styles/index.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  inheritAttrs: !1,
  __name: "TooltipContent",
  props: {
    class: {},
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, delegatedProps = reactiveOmit(props, ["class"]), forwarded = useForwardPropsEmits(delegatedProps, emits), { teleportRenderDisabled } = useConfigProvider(), tooltipContentClasses = tooltipContentVariants();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(TooltipPortal_default), { disabled: unref(teleportRenderDisabled) }, {
      default: withCtx(() => [
        createVNode(unref(TooltipContent_default), mergeProps({ "data-slot": "tooltip-content" }, { ...unref(forwarded), ..._ctx.$attrs }, {
          class: unref(cn)(unref(tooltipContentClasses).base(), props.class)
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default"),
            createVNode(unref(TooltipArrow_default), {
              class: normalizeClass(unref(tooltipContentClasses).icon())
            }, null, 8, ["class"])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipContent.vue.js.map
